import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminTraining from './AdminTraining';

export default withRequiredAdmin(AdminTraining);
